import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiUser, FiLock, FiAlertCircle } from 'react-icons/fi';
import loginBgImage from '../assets/images/login-bg.jpeg';
import logoImage from '../assets/images/vgp-logo.png';
import './Login.css';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { mustChangePassword } = await login(credentials.username, credentials.password);
      if (mustChangePassword) {
        navigate('/change-password', { replace: true });
      } else {
        navigate(from, { replace: true });
      }
    } catch (err) {
      const msg =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        err.response?.data?.non_field_errors?.[0] ||
        'Invalid username or password.';
      setError(typeof msg === 'string' ? msg : 'Invalid username or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div
        className="login-page-bg"
        style={{ backgroundImage: `url(${loginBgImage})` }}
        aria-hidden="true"
      />
      <div className="login-card">
        <div className="login-card-logo">
          <img src={logoImage} alt="VGP Wonder World" className="login-logo-img" />
        </div>
        <h1 className="login-title">Admin Login</h1>
        <p className="login-subtitle">Sign in to manage your bookings and settings</p>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="login-username">Username</label>
            <div className="input-wrap">
              <FiUser className="input-icon" aria-hidden="true" />
              <input
                id="login-username"
                type="text"
                value={credentials.username}
                onChange={(e) =>
                  setCredentials((c) => ({ ...c, username: e.target.value }))
                }
                placeholder="Enter your username"
                required
                autoComplete="username"
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="login-password">Password</label>
            <div className="input-wrap">
              <FiLock className="input-icon" aria-hidden="true" />
              <input
                id="login-password"
                type="password"
                value={credentials.password}
                onChange={(e) =>
                  setCredentials((c) => ({ ...c, password: e.target.value }))
                }
                placeholder="Enter your password"
                required
                autoComplete="current-password"
              />
            </div>
          </div>
          {error && (
            <div className="error-message" role="alert">
              <FiAlertCircle className="error-icon" aria-hidden="true" />
              {error}
            </div>
          )}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? (
              <>
                <span className="btn-spinner" aria-hidden="true" />
                Signing in…
              </>
            ) : (
              'Sign in'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
